/**
 * Brand backdrop for the sign-in screens.
 *
 * The wash is the exported brand artboard itself (`public/background.svg`, 1728x1117):
 * a #AA43FF -> #662899 diagonal base under a #AA43FF / #851AD6 / #5D178C radial centred
 * on the top edge at 15% of the width. It is painted `object-cover` so the radial keeps
 * its shape on any viewport, over a flat #5D178C on the page so nothing flashes white
 * while the asset loads.
 *
 * The two layers above it belong to the composition rather than the asset: a soft
 * highlight that lifts the white card off the wash, and a bottom shade that carries the
 * footer text into a darker band where it stays readable.
 */
export function AuthBackdrop({ className }: { className?: string }) {
  return (
    <div className={className} aria-hidden>
      <img
        src="/background.svg"
        alt=""
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[radial-gradient(58%_46%_at_50%_44%,rgba(255,255,255,0.14),transparent_72%)]" />
      <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-[#3E0E62]/50 via-[#3E0E62]/15 to-transparent" />
    </div>
  )
}
